// extracted by mini-css-extract-plugin
export default {"wrapper":"DeletePWAModal_wrapper__9sG-e","warning":"DeletePWAModal_warning__RRtPd","info":"DeletePWAModal_info__naiGT"};